var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.06,
    height: 94.666,
    viewBox: "0 0 86.06 94.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "lock",
    d: "M43.03,0A25.818,25.818,0,0,1,68.848,24.85V38.727h4.3A12.909,12.909,0,0,1,86.039,50.879l.021.757V81.757A12.909,12.909,0,0,1,73.151,94.666H12.909A12.909,12.909,0,0,1,0,81.757H0V51.636A12.909,12.909,0,0,1,12.909,38.727h4.3V25.818A25.818,25.818,0,0,1,43.03,0ZM73.151,47.333H12.909a4.3,4.3,0,0,0-4.3,4.3h0V81.757a4.3,4.3,0,0,0,4.3,4.3H73.151a4.3,4.3,0,0,0,4.3-4.3h0V51.636A4.3,4.3,0,0,0,73.151,47.333ZM43.03,8.606A17.212,17.212,0,0,0,25.818,24.957v13.77H60.242V25.818A17.212,17.212,0,0,0,43.03,8.606Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.fd14399721ada28048f4a9e26cdcb38f.svg";
export { ForwardRef as ReactComponent };